import React, { useState } from "react";
import logo from "../../Assets/Logo/small.png";
import lock from "../../Assets/Icon/lock.webp";
import { useNavigate } from "react-router-dom";
import { ChangeNewPassword } from "../../Repository/Api";
import { useSelector } from "react-redux";
import { errorMsg, successMsg } from "../Toastify";

const ChangePassword = () => {
  const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const navigate = useNavigate();

  const [login, SetLogin] = useState([]);
  const [validation, setValidation] = useState({});

  const [password, setPassword] = useState();
  const viewPassword = () => {
    setPassword(!password);
  };
  const [password2, setPassword2] = useState();
  const viewPassword2 = () => {
    setPassword2(!password2);
  };
  const [password3, setPassword3] = useState();
  const viewPassword3 = () => {
    setPassword3(!password3);
  };

  const setData = (e, key) => {
    let TempData = login;
    TempData[key] = e;
    SetLogin(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!login.old_password) {
      validdateData.old_password = "Old Password is Required";
      Status = false;
    }
    if (!login.new_password) {
      validdateData.new_password = "New Password is Required";
      Status = false;
    } else if (login.new_password.localeCompare(login.repassword) !== 0) {
      validdateData.repassword =
        "new Password and Re-Enter Password doesn't match";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      old_password: login.old_password,
      new_password: login.new_password,
    };
    if (CheckValidation()) {
      const response = await ChangeNewPassword(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        getTimeout();
      } else {
        errorMsg(response.message);
      }
    }
  };

  const getTimeout = () => {
    setTimeout(() => {
      setTimeout(navigate("/Login"));
    }, 1000);
  };

  return (
    <>
      <section className="signin">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 ms-auto mx-auto">
              <div className="signinlogospace">
                <div className="centertext">
                  <img className="signinlogo" src={logo} alt="NITTTR" />
                </div>
                <div className="my-5">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="inputspace">
                      <img className="icon" src={lock} alt="User" />
                      <input
                        type={password ? "text" : "password"}
                        className="input-field"
                        placeholder="OLD PASSWORD"
                        defaultValue={login.old_password}
                        onChange={(e) => {
                          setData(e.target.value, "old_password");
                        }}
                      />
                      <div className="psw-icon">
                        {password ? (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility
                          </span>
                        ) : (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility_off
                          </span>
                        )}
                      </div>
                      {validation.old_password && (
                        <p className="validationmsg">
                          {validation.old_password}
                        </p>
                      )}
                    </div>
                    <div className="inputspace">
                      <img className="icon" src={lock} alt="User" />
                      <input
                        type={password2 ? "text" : "password"}
                        className="input-field"
                        placeholder="NEW PASSWORD"
                        defaultValue={login.new_password}
                        onChange={(e) => {
                          setData(e.target.value, "new_password");
                        }}
                      />
                      <div className="psw-icon">
                        {password2 ? (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword2()}
                          >
                            visibility
                          </span>
                        ) : (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword2()}
                          >
                            visibility_off
                          </span>
                        )}
                      </div>
                      {validation.new_password && (
                        <p className="validationmsg">
                          {validation.new_password}
                        </p>
                      )}
                    </div>
                    <div className="inputspace">
                      <img className="icon" src={lock} alt="User" />
                      <input
                        type={password3 ? "text" : "password"}
                        className="input-field"
                        placeholder="CONFIRM PASSWORD"
                        onChange={(e) => {
                          setData(e.target.value, "repassword");
                        }}
                      />
                      <div className="psw-icon">
                        {password3 ? (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword3()}
                          >
                            visibility
                          </span>
                        ) : (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword3()}
                          >
                            visibility_off
                          </span>
                        )}
                      </div>
                      {validation.repassword && (
                        <p className="validationmsg">{validation.repassword}</p>
                      )}
                    </div>
                    <div className="inputspace">
                      <button className="loginbtn"> Change Password </button>
                    </div>
                    <p
                      className="text-end cursor"
                      onClick={() => {
                        navigate("/app/dashboard");
                      }}
                    >
                      <small>Back to Dashboard</small>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChangePassword;
